module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "tabela tabela_listrada tabela_com-largura-total"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.aportes), function(aporte) {
    return _c('tr', {
      key: aporte.Id
    }, [_c('td', [_vm._v(_vm._s(_vm.$moeda.formatar(aporte.Valor)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(aporte.Usuario.Nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$tempo.formatarParaPadraoBrasileiro(aporte.Data)))])])
  }), _vm._v(" "), (_vm.aportes.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Nenhum aporte foi encontrado")])]) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Valor")]), _vm._v(" "), _c('th', [_vm._v("Usuário")]), _vm._v(" "), _c('th', [_vm._v("Data")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-320177ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/aportes/TabelaDeAportes.vue
// module id = 1105
// module chunks = 1